import React from 'react';
import { Consumer } from '../context';
import FaqLink from '../../../faq-link/FaqLink';
import { DataUploaderMode } from '../types';
import { getHelpCenterLinks } from 'venn-ui-kit';

const getLink = (mode: DataUploaderMode) => {
  switch (mode) {
    case DataUploaderMode.NewNavs:
      return getHelpCenterLinks().INVESTMENT_UPLOADER_FAQ_HREF;
    case DataUploaderMode.Returns:
      return getHelpCenterLinks().RETURNS_UPLOADER_FAQ_HREF;
    case DataUploaderMode.Privates:
      return getHelpCenterLinks().PRIVATE_ASSET_UPLOADER_FAQ_HREF;
    default:
      throw new Error(`Unknown uploader mode ${mode}`);
  }
};

const UploaderFaqLink = () => <Consumer>{({ mode }) => <FaqLink link={getLink(mode)} />}</Consumer>;
export const UploaderFaqLinkShared = (mode: DataUploaderMode) => <FaqLink link={getLink(mode)} />;

export default UploaderFaqLink;
